export const size = {
  BAR_MAX_WIDTH: 150,
  BAR_X_LABEL_MAX_WIDTH: 180,
};
